import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { MatchedSubstring } from './matched-substring.model';

export const HIGHLIGHT_SCHEMA = Object.freeze({
  REF_ID: '',
  MATCHED_SUBSTRINGS: List<MatchedSubstring>(),
});
const RECORD = generateSchema(HIGHLIGHT_SCHEMA);
const KEYS: any = generateKeys(HIGHLIGHT_SCHEMA);

export class Highlight extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.MATCHED_SUBSTRINGS,
        value: this.get(KEYS.MATCHED_SUBSTRINGS)
          ? this.matchedSubstrings.map((params) => new MatchedSubstring(params))
          : List<MatchedSubstring>([]),
      },
    ]);

    return selfModel as Highlight;
  }

  get refId(): string {
    return this.get(KEYS.REF_ID);
  }

  get matchedSubstrings(): List<MatchedSubstring> {
    return this.get(KEYS.MATCHED_SUBSTRINGS);
  }

  getSubstringForPath(path: string[]): MatchedSubstring {
    const serializedPath: string = path.join('.');

    return this.matchedSubstrings.find(
      (matchedSubstring: MatchedSubstring) =>
        serializedPath === matchedSubstring.path
    );
  }
}
